class MailChimpController extends AbstractIntegrationController
	@register()
	@inject 'configuration',
		'shops'
		'customerGroups'
		'BACKEND_MAIL_CHIMP_TARGET_TYPE'
		'IntegrationRepository'
		'ToastService'

	integrationId: 'mail_chimp'

	initialize: ->
		@configuration ?= {}
		@sending = false
		@shops = if Array.isArray(@shops) then angular.copy(@shops) else []
		@customerGroups = if Array.isArray(@customerGroups) then angular.copy(@customerGroups) else []
		@targetTypes = _.map @BACKEND_MAIL_CHIMP_TARGET_TYPE, (targetType) =>
			id: targetType
			name: @translate('wbo.integration.mail_chimp.target_type.' + targetType)
		@targetLabel = 'general.customer.group'
		@targetOptions = angular.copy(@customerGroups)
		@tabs = [
			{
				title: 'wbo.integration.mail_chimp.tab.configuration'
				selector: '#tab-mail-chimp-configuration'
			}
			{
				title: 'wbo.integration.mail_chimp.tab.send'
				selector: '#tab-mail-chimp-send'
			}
		]

		@resetCampaignForm()

	save: ->
		return super(@configuration).then (response) =>
			@configuration = response.data

	afterDisconnect: ->
		@configuration = {}
		@resetCampaignForm()

	sendCampaign: ->
		return if @sending || !@isCampaignReady()

		@sending = true
		@resetErrors()

		@IntegrationRepository
			.customPost @integrationId, 'send', @campaign
			.then =>
				@resetCampaignForm()
				@ToastService.add(
					@translate(@headerText),
					@translate('general.integration'),
					@translate('wbo.integration.mail_chimp.send.scheduled'),
					'success'
				)
			.catch (response) =>
				@handleErrors(response)
				@ToastService.showErrors response, @translate(@headerText)
			.finally =>
				@sending = false

	handleTargetTypeChange: ->
		@campaign.target_id = null
		@updateTargetSelection()

	isCampaignReady: ->
		return false unless @configuration.is_active

		return @hasValue(@campaign?.title) &&
			@hasValue(@campaign?.body) &&
			@hasValue(@campaign?.target_type) &&
			@hasValue(@campaign?.target_id)

	resetCampaignForm: ->
		@campaign =
			title: null
			body: null
			target_type: @campaign?.target_type ? @BACKEND_MAIL_CHIMP_TARGET_TYPE.CUSTOMER_GROUP
			target_id: null

		@updateTargetSelection()

		@sendForm?.$setPristine()
		@sendForm?.$setUntouched()

	updateTargetSelection: ->
		if @campaign.target_type == @BACKEND_MAIL_CHIMP_TARGET_TYPE.SHOP
			@targetLabel = 'general.shop'
			@targetOptions = angular.copy(@shops)
			return

		@targetLabel = 'general.customer.group'
		@targetOptions = angular.copy(@customerGroups)

	hasValue: (value) ->
		if !value?
			return false

		if angular.isString(value)
			return value.trim().length > 0

		return true
